var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterSubGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.38464,
    y: 0.5,
    width: 8.61538,
    height: 3,
    rx: 0.5,
    fill: "white",
    stroke: "#9296AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 14.3846,
    height: 7,
    rx: 1,
    fill: "white",
    stroke: "#9296AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.38464,
    y: 7.5,
    width: 8.61538,
    height: 7,
    rx: 1,
    fill: "white",
    stroke: "#9296AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5769 4.5C10.5769 4.22386 10.6538 4 10.7486 4H12.809C12.9039 4 12.9808 4.22386 12.9808 4.5C12.9808 4.77614 12.9039 5 12.809 5H10.7486C10.6538 5 10.5769 4.77614 10.5769 4.5Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterSubGray);
export default __webpack_public_path__ + "static/media/printerSubGray.d093f6dbc6f01b70c8b7a5ef5e7275e5.svg";
export { ForwardRef as ReactComponent };